 import { RootState } from 'app/store';

export const selectHeatMap = (state: RootState) => state.measures.heatMap.data;

export const selectHeatMapPagination = (state: RootState) => state.measures.heatMap.pagination;

export const selectMeasure = (state: RootState) => state.measures.measure.data;

export const selectTsvMeasureTypes = (state: RootState) => state.measures.tsvMeasureTypes;
